// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonMoreCenteredError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M7 12C7 13.1046 6.10457 14 5 14 3.89543 14 3 13.1046 3 12 3 10.8954 3.89543 10 5 10 6.10457 10 7 10.8954 7 12ZM14 12C14 13.1046 13.1046 14 12 14 10.8954 14 10 13.1046 10 12 10 10.8954 10.8954 10 12 10 13.1046 10 14 10.8954 14 12ZM20.9948 11.8542C20.288 11.6243 19.5335 11.5 18.75 11.5 18.1542 11.5 17.5753 11.5719 17.0213 11.7074 17.1628 10.7415 17.9948 10 19 10 20.0555 10 20.9201 10.8177 20.9948 11.8542Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonMoreCenteredError is a generated icon component.
 */
let IconCommonMoreCenteredError = IconCommonMoreCenteredError_1 = class IconCommonMoreCenteredError extends IconBaseElement {
    render() {
        return html `${IconCommonMoreCenteredError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonMoreCenteredError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonMoreCenteredError = IconCommonMoreCenteredError_1 = __decorate([
    customElement('zui-icon-common-more-centered-error')
], IconCommonMoreCenteredError);
export { IconCommonMoreCenteredError };
